import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';

const CostOfInaction = () => {
  const points = [
    {
      title: "Lost Revenue",
      desc: "Every day without an automated lead system is ₹5,000 - ₹15,000 in missed sales that your competitors are grabbing.",
      icon: FiIcons.FiTrendingDown,
      color: "text-red-400"
    },
    {
      title: "Time Bankruptcy",
      desc: "Spending 4+ hours daily on manual follow-ups and content creation instead of high-level strategy and growth.",
      icon: FiIcons.FiClock,
      color: "text-orange-400"
    },
    {
      title: "Market Irrelevance",
      desc: "AI is moving at 10x speed. If you don't install an AI OS now, your skills will be obsolete by next year.",
      icon: FiIcons.FiAlertCircle,
      color: "text-yellow-400"
    }
  ];

  return (
    <section className="py-24 px-6 bg-slate-950 border-t border-slate-900">
      <div className="max-w-5xl mx-auto">
        <div className="bg-gradient-to-br from-red-950/20 to-slate-900 p-8 md:p-12 rounded-[2.5rem] border border-red-500/20 shadow-2xl relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-red-500/5 blur-[100px]"></div>
          
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4">
              The Real Cost of <span className="underline decoration-red-500 underline-offset-8">Doing Nothing</span>
            </h2>
            <p className="text-slate-400 text-lg">Staying where you are is the most expensive decision you'll make this year.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {points.map((point, i) => (
              <div key={i} className="bg-slate-950/40 p-6 rounded-2xl border border-slate-800">
                <div className={`${point.color} mb-4`}>
                  <SafeIcon icon={point.icon} className="text-3xl" />
                </div>
                <h4 className="text-white font-bold text-xl mb-3">{point.title}</h4>
                <p className="text-slate-500 text-sm leading-relaxed">{point.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-slate-800 text-center">
            <p className="text-slate-300 font-medium">
              "The price of discipline is always less than the price of regret."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CostOfInaction;